/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-04-01 15:40:26
 * @LastEditTime: 2022-04-14 16:05:44
 * @FilePath: \insurforce-backstage-platform-side\src\views\insurance\classManage\request.js
 */
import request from '@/utils/request';

/**获取列表数据 */
export function insuranceClassList(data) {
  return request.post('admin/insurance-sort/list', data);
}
// 产品大类-新增
export function insuranceClassAdd(data) {
  return request.post('admin/insurance-sort/store', data);
}

// 产品大类-编辑
export function insuranceClassEdit(data) {
  return request.post('admin/insurance-sort/edit', data);
}
// 产品大类-删除
export function insuranceClassDelete(data) {
  return request.post('admin/insurance-sort/delete', data);
}

// 产品大类-详情
export function insuranceClassDetail(data) {
  return request.post('admin/insurance-sort/detail', data);
}

// 产品大类-状态更新
export function insuranceClassUpdate(data) {
  return request.post('admin/insurance-sort/update', data);
}

// 产品大类-资源
export function insuranceClassResource(data) {
  return request.post('admin/insurance-sort/resource', data);
}